<ion-select
  label="Baustelle"
  label-placement="floating"
  fill="outline"
  (ionChange)="handleClick($event.detail.value)"
  [multiple]="multiple"
  [value]="preselectedConSite"
  mode="md"
  interface="popover"
  [interfaceOptions]="popoverOptions"
>
  <ion-select-option [value]="null" *ngIf="showAllEntry"
    >Alle Baustellen</ion-select-option
  >
  <ion-select-option
    *ngFor="let conSite of this.activeConSites$ | async"
    [value]="conSite.id"
    [disabled]="
      blackList?.includes(conSite.id) && conSite.id != this.selectedConSite
    "
    >{{ conSite.name }}</ion-select-option
  >
</ion-select>
